// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"046685ad","453":"b3be4702","559":"6a94856c"}[chunkId] + ".chunk.js";
};